import React from "react";
import "./stats.css";
import { getHomeAdv } from "./pages/Schedule";

const StatsMatch = ({ statistics, isDarkMode, onStatisticClick }) => {
  return (
    <div className="stats-wrapper">
      {statistics.map((statistic, index) => {
        if (+statistic.home === 0 && +statistic.away === 0) return null;
        
        let homeValue = parseFloat(statistic.home) || 0;
        let awayValue = parseFloat(statistic.away) || 0;
        let adjustedHomeValue = 0;
        let adjustedAwayValue = 0;
        let total = 0;
    
        if (homeValue >= 0 && awayValue < 0) {
          // Home is positive, away is negative
          adjustedHomeValue = homeValue + Math.abs(awayValue); // Add the magnitude of the negative value
          adjustedAwayValue = Math.abs(awayValue); // Use the magnitude of the negative value
        } else if (homeValue < 0 && awayValue >= 0) {
          // Home is negative, away is positive
          adjustedHomeValue = Math.abs(homeValue); // Use the magnitude of the negative value
          adjustedAwayValue = awayValue + Math.abs(homeValue); // Add the magnitude of the negative value
        } else if (homeValue < 0 && awayValue < 0) {
          // Both are negative: smaller magnitude is better
          adjustedHomeValue = Math.abs(1 / homeValue); // Invert to make smaller negatives larger
          adjustedAwayValue = Math.abs(1 / awayValue);
        } else {
          // Both are positive
          adjustedHomeValue = homeValue;
          adjustedAwayValue = awayValue;
        }

        if (adjustedHomeValue > adjustedAwayValue) {
          adjustedHomeValue *= 1.5; // Amplify home value by 20%
        } else if (adjustedAwayValue > adjustedHomeValue) {
          adjustedAwayValue *= 1.5; // Amplify away value by 20%
        }


        
        if (statistic.type === "Power Rating" && homeValue <= 1000) {
          // const maxDifference = 30;
          
          homeValue += 2.5
          // Calculate the absolute difference
          // let subtotal = (homeValue + awayValue) / 2;
          let subtotal = 20
          const diff = homeValue - awayValue;

          adjustedHomeValue = subtotal + diff;
          adjustedAwayValue = subtotal - diff;
        
          // Total is always the max difference for Power Rating
          total = subtotal*2;
        } else {
          total = adjustedHomeValue + adjustedAwayValue;
        }


        // Avoid division by zero
        if (total === 0) {
          total = 1;
        }
        
        // Calculate percentages
        let homePercentage = Math.round((adjustedHomeValue / total) * 100);
        let awayPercentage = Math.round((adjustedAwayValue / total) * 100);
        
        // Handle specific types like "Pts Against" or "Def Eff" by swapping percentages
        if (statistic.type === "Pts Against" || statistic.type === "Def Eff" || statistic.type === "Rush Yds Ag" || statistic.type === "Rush Eff" || statistic.type === "Penalty Yds" || statistic.type === "Giveaways" || statistic.type === "Pass Yds Ag" || statistic.type === "Errors") {
          [homePercentage, awayPercentage] = [awayPercentage, homePercentage];
        }
        
        const clickableStats = ["Pts For", 
          "Pts Against", 
          "Pass Yards", 
          "Pass Yds Ag", 
          "Rush Yds", 
          "Rush Yds Ag", 
          "Penalty Yds", 
          "Penalty Yds Ag", 
          "Shooting", 
          "Def Eff",
          "Pace",
          "Steals",
          "Giveaways",
          "Takeaways",
          "Margin",
          "Power Rating",
          "PP",
          "PK",
          "Faceoff",
          "Rest",
          "Shots (% For)",
          "Errors",
          "Hits (Diff)",
          'Avg vs Hand',
          'Mult vs Hand'
        ];

        const handleStatClick = (statistic, event) => {
          // Determine if away (left) or home (right) was clicked based on click position
          if (!clickableStats.includes(statistic.type)) return;

          const rect = event.currentTarget.getBoundingClientRect();
          const clickX = event.clientX - rect.left;
          const midpoint = rect.width / 2;
          const location = clickX < midpoint ? 'away' : 'home';
          
          onStatisticClick && onStatisticClick({ ...statistic, location });
        };

        return (
          <div key={index} className="stats-container" style={{ cursor: 'pointer' }}>
            <div 
              className="stats-main"
              onClick={(e) => handleStatClick(statistic, e)}
            >
              <div className="stats-value">{statistic.away}</div>
              <div className="stats-type">{statistic.type}</div>
              <div className="stats-value">{statistic.home}</div>
            </div>
            <div className="stats-chart single-bar">
              <div
                className="chart-fill away-fill"
                style={{
                  width: `${awayPercentage}%`,
                  // backgroundColor: isDarkMode ? "#fff" : "#001e28",
                }}
              ></div>
              <div
                className="chart-fill home-fill"
                style={{
                  width: `${homePercentage}%`,
                  // backgroundColor: isDarkMode ? "#ff0046" : "#ff0046",
                }}
              ></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsMatch;